import { render, staticRenderFns } from "./itemMertCaseList.vue?vue&type=template&id=609e4966&scoped=true&"
import script from "./itemMertCaseList.vue?vue&type=script&lang=js&"
export * from "./itemMertCaseList.vue?vue&type=script&lang=js&"
import style0 from "./itemMertCaseList.vue?vue&type=style&index=0&id=609e4966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609e4966",
  null
  
)

export default component.exports